import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("div")`
    width: 100%;
    min-height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: ${({theme}) => theme.uxfabric.components.menu.megaMenu.navigationList.quickLinks.backgroundColor};
    border-bottom: 0.0625rem solid
        ${({theme}) => theme.uxfabric.components.menu.megaMenu.navigationList.quickLinks.divider.default.borderColor};
    text-decoration: none;
`

export const StyledA = styled("a")`
    display: inherit;
    text-decoration: inherit;
    flex-direction: inherit;
    justify-content: inherit;
    width: inherit;
`

export const StyledBtn = styled("button")`
    padding: inherit;
    display: inherit;
    text-decoration: inherit;
    flex-direction: inherit;
    justify-content: inherit;
    width: inherit;
    border: unset;
    background: inherit;
    align-items: inherit;
    cursor: pointer;
`
export const LinkContainer = styled("div")`
    flex-direction: row;
    display: inherit;
    align-items: center;
`
export const TextContainer = styled("div")`
    flex-direction: column;
    display: inherit;
    padding-left: 0.75rem;
`
export const Text = styled(Typography)`
    display: inherit;
    line-height: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.lineHeight};
    text-transform: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.textTransform};
    font-weight: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.fontWeight};
    font-size: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.fontSize};
    letter-spacing: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.letterSpacing};
    font-family: ${({theme}) => `${theme.uxfabric.component.listItemSubtitle1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
`
export const DescriptionText = styled(Typography)`
    color: ${({theme}) => theme.uxfabric.text.secondary as string};
    display: inherit;
    font-family: ${({theme}) => theme.uxfabric.component.listItemDescription.fontFamily}, ${FALLBACK_FONT_FAMILY}};
    font-size: ${({theme}) => theme.uxfabric.component.listItemDescription.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.listItemDescription.fontWeight};
    line-height: ${({theme}) => theme.uxfabric.component.listItemDescription.lineHeight};
`

export const IconContainer = styled("div")`
    width: 1.5rem;
    height: 1.5rem;
    display: inherit;
    align-items: center;
    justify-content: center;
    margin-left: 1rem;
`

export const Icon = styled("img")(({fixedHeight, fixedWidth}: {fixedHeight?: number; fixedWidth?: number}) => ({
    cursor: "pointer",
    height: fixedHeight || "auto",
    width: fixedWidth || "auto",
}))
